const managebanner = {
  path: 'agentbanner/managebanner',
  component: resolve => require(['@/pages/admin/businessmag/agentbanner/managebanner'], resolve),
  meta: {
    requireAuth: true
  },
  children: [
    // aftersalesReplayList,
  ]
}

export default managebanner